import PrintProductConfigurator from './PrintProductConfigurator';
import PrintProductConfiguratorModal from './modal';

export { PrintProductConfiguratorModal };
export default PrintProductConfigurator;
